// test1542
(1542 && 0);
